// src/components/Contact.js
import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="bg-custom-orange py-12">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold mb-9 ">Contact Me</h2>
        <p className=" text-xl mb-4">Feel free to leave me a message</p>
       <a href="mailto:imroatussholikhahnf@gmail.com" className="bg-custom-orange2 text-white font-bold py-2 rounded-lg shadow-md transition duration-300 px-8">
        Send Mail
       </a>
      </div> 
    </section>
  );
};

export default Contact;
